import message from "./message";

// useage:
// this.$message.success(String)、this.$message.info(String)、this.$message.error(String)
export default {
  install(Vue) {
    Vue.prototype.$message = message;
  }
};
